export const airFreightServicesTitile = "International Air Freight Services";

export const airFreightServices = [
  "Expedited air freight services for high-value technology shipments",
  "Door-to-door international transport with single-carrier responsibility",
  "Priority boarding and handling at origin and destination",
  "Advanced pre-clearance arrangements minimizing ground time",
  "Specialized Aircraft Options: access to specialized freighter aircraft for oversized technology equipment",
  "Temperature-controlled cargo compartments for sensitive electronics",
  "Reduced handling points minimizing damage and security risks",
  "Preferred partnerships with premium carriers specializing in valuable cargo",
  "Dedicated space agreements ensuring capacity during peak periods",
  "Access to specialized handling services at major global airports",
];

export const securityServices = [
  {
    title: "Secure Handling Facilities operating 24/7",
    items: [
      "Our cross-dock facilities are certified under the TAPA A standards, ensuring the highest level of security for your high-tech goods."
    ]
  },
  {
    title: "Trucking Security Requirements (TSR) Level 1 & 2 Escort Services",
    items: [
      "Strict adherence to TAPA's Trucking Security Requirements",
      "Trained security personnel accompanying high-value shipments",
      "Real-time route monitoring and contingency planning"
    ]
  },
  {
    title: "Armed Security Services",
    items: [
      "Enhanced protection for ultra-high-value technology shipments",
      "Professionally trained armed security specialists",
      "Covert and overt security options based on threat assessment"
    ]
  }
]

export const charterAndComplianceSections = [
  {
    title: "Charter Services (Full or Partial)",
    items: [
      "Customized air freight solutions for time-critical technology movements",
      "Dedicated aircraft options eliminating co-loading risks",
      "Flexible partial charter options for cost optimization",
      "Direct ramp access for minimized handling"
    ]
  },
  {
    title: "Customs Brokerage & Compliance",
    items: [
      "Dedicated high-tech customs specialists",
      "Pre-clearance preparation to minimize delays",
      "Expertise in technology-specific import/export regulations",
      "Trade compliance consulting services"
    ]
  }
];
